
const FacebookIcon = ({
    width = 32,
    height = 32,
    ...props }) => (

    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        baseProfile="basic"
        width={width || "100%"}
        height={height || "100%"}
        viewBox="0 0 30 30"
        {...props}
    >
        <path d="M20.9792 16.2434L21.7372 11.2524H16.9957V8.01306C16.9957 6.64929 17.6568 5.31724 19.7805 5.31724H21.9375V1.06818C21.9375 1.06818 19.9808 0.730957 18.111 0.730957C14.2043 0.730957 11.6533 3.1219 11.6533 7.44852V11.2524H7.3125V16.2434H11.6533V28.3094C12.5247 28.4476 13.4163 28.5185 14.3245 28.5185C15.2327 28.5185 16.1242 28.4476 16.9957 28.3094V16.2434H20.9792Z" />

    </svg>
)
export default FacebookIcon

